import * as React from "react";
import { SingleNavMenuLinkDivider as ISingleNavMenuLinkDivider } from "../../../pages/identity/useNavMenu";
import { Divider } from "antd";

interface Props {
  link: ISingleNavMenuLinkDivider;
  index: number;
}
export const SingleNavMenuLinkDivider: React.FC<Props> = ({ link, index }) => {
  return (
    <div className="px-4">
      <Divider style={{ marginBlock: 8, marginInline: 0 }} />
    </div>
  );
};
